module.exports = __webpack_public_path__ + "img/ug.e76a6f85.svg";